import { Link } from 'react-router-dom'
import { BrandLogo } from '../shared/BrandLogo'
import './web-test-motion.css'
import './web-test-hero.css'
import './web-test-legal.css'
import { WebsiteThemeToggle } from './WebsiteThemeToggle'
import { SeoHead } from './seo/SeoHead'
import { getPageSeo } from './seo/pages'
import { defaultPageGraph } from './seo/jsonld'

export function WebTestNotFoundPage() {
  const seo = getPageSeo('/404')!

  return (
    <div className="wt-page wl-page">
      <SeoHead path="/404" jsonLd={defaultPageGraph(seo)} />
      <header className="wl-header">
        <div className="wl-header__inner">
          <BrandLogo className="wt-logo" tone="light" to="/" />
          <nav className="wl-header__nav" aria-label="Secondary">
            <Link to="/about">About</Link>
            <Link to="/support">Support</Link>
            <Link to="/contact">Contact</Link>
          </nav>
          <div className="wl-header__actions">
            <WebsiteThemeToggle />
            <Link className="wt-btn wt-btn--primary" to="/">
              Home
            </Link>
          </div>
        </div>
      </header>

      <main className="wl-main">
        <div className="wl-inner">
          <p className="wl-eyebrow">Error 404</p>
          <h1 className="wl-title">Page Not Found</h1>
          <p className="wl-section" style={{ color: 'var(--wt-muted)' }}>
            The page you requested is not available on the Perfect Predict public website.
          </p>
          <p className="wl-back">
            <Link className="wt-btn wt-btn--primary" to="/">
              Back to homepage
            </Link>
          </p>
          <nav className="wl-section" aria-label="Helpful links">
            <ul style={{ paddingLeft: '1.2rem' }}>
              <li>
                <Link to="/how-perfect-predict-works">How Perfect Predict works</Link>
              </li>
              <li>
                <Link to="/support">Support</Link>
              </li>
              <li>
                <Link to="/contact">Contact</Link>
              </li>
            </ul>
          </nav>
        </div>
      </main>
    </div>
  )
}
